import dashboard from "@/views/dashboard/index";

export default [
  {
    path: "/activities",
    name: "activities",
    component: dashboard,
    redirect: {
      name: "activitiesIndex"
    },
    children: [
      {
        path: "activitiesIndex",
        name: "activitiesIndex",
        meta: { title: "生效中的活码管理" },
        component: () => import("@/views/activities/index.vue"),
        children: [
          {
            path: "editActivitiesInfoById/:activitiesId",
            name: "editActivitiesInfoById",
            meta: { title: "修改活码" },
            component: () => import("@/views/activities/activitiesManage.vue")
          }
        ]
      },
      {
        path: "brandCategory",
        name: "brandCategory",
        meta: { title: "品牌品类管理" },
        component: () => import("@/views/country/brandCategory/index.vue"),
        children: [
          {
            path: "brandManage",
            name: "brandManage",
            meta: { title: "品牌品类信息维护" },
            component: () =>
              import("@/views/country/brandCategory/brandManage.vue")
          }
        ]
      }
    ]
  }
];
